<div class="unities-dropdown" [ngClass]="{ open: show }">
  <p class="unities-dropdown-title">Units</p>
  <ul>
    <li *ngFor="let unit of units" (click)="selectUnit(unit)" class="unities-dropdown-option">
      <i *ngIf="unit.value === selectedUnit" class="fas fa-check"></i>
      {{ unit.value }}
    </li>
  </ul>
</div>
